import dayjsTZ from "../../../../utils/dayjs";
import {
  buildReportResult,
  emptyReportResult,
  employeeFullName,
  intervalBounds,
} from "../reportResult";

/**
 * Leave coverage: one row per employee-day on approved leave in range.
 * Useful as a flat “who is out” export for the period.
 */
export const leaveCoverage = (
  data,
  filter,
  columns,
  manualColumns,
  employees,
) => {
  if (!filter) return emptyReportResult(columns, manualColumns);

  const { startTs, endTs } = intervalBounds(filter);
  const requests = data || [];
  const empBySub = new Map((employees || []).map((e) => [e.userSub, e]));

  const preFilter = [];
  for (const req of requests) {
    if (req?.requestStatus !== "Aprovuar") continue;
    const period = Array.isArray(req.requestPeriod) ? req.requestPeriod : [];
    const emp = req.employeeDetails || empBySub.get(req.userSub) || {};
    if (filter?.employeeId && emp.employeeId !== filter.employeeId) continue;

    for (const p of period) {
      const t = dayjsTZ(p).valueOf();
      if (t < startTs || t > endTs) continue;
      preFilter.push({
        employee: employeeFullName(emp) || `${req.given_name || ""} ${req.family_name || ""}`.trim(),
        employeeDepartmentName: emp.employeeDepartmentName || "",
        employeeTeam: emp.employeeTeam || "",
        requestType: req.requestType || "",
        leaveDate: dayjsTZ(p).format("DD/MM/YYYY"),
        dayName: dayjsTZ(p).format("dddd"),
        requestStatus: req.requestStatus,
      });
    }
  }

  preFilter.sort((a, b) => {
    const byDate =
      dayjsTZ(a.leaveDate, "DD/MM/YYYY").valueOf() -
      dayjsTZ(b.leaveDate, "DD/MM/YYYY").valueOf();
    if (byDate) return byDate;
    return String(a.employee).localeCompare(String(b.employee), "sq");
  });

  return buildReportResult(preFilter, columns, manualColumns);
};
